import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bp-header-updates',
  templateUrl: './header-updates.component.html',
  styleUrls: ['./header-updates.component.scss']
})
export class HeaderUpdatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
